let _initProto, _initClass, _init_target, _init_extra_target, _init_headingSelector, _init_extra_headingSelector, _init_label, _init_extra_label, _init_scrollOffset, _init_extra_scrollOffset, _init_navigationEvents, _init_extra_navigationEvents, _init_entries, _init_extra_entries, _init_activeId, _init_extra_activeId;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { RadiantElement, bound, customElement, onUpdated, prop, state } from "@ecopages/radiant";
import { isServer } from "@ecopages/radiant/is-server";
import { parseCommaSeparated } from "@/lib/comma-separated";
import { ensureUniqueHeadingId, querySelectorAllSafe, querySelectorSafe, scrollHeadingIntoView, trackingLineY } from "./toc-helpers";
let _RuiToc;
class RuiToc extends RadiantElement {
  static {
    ({
      e: [_init_target, _init_extra_target, _init_headingSelector, _init_extra_headingSelector, _init_label, _init_extra_label, _init_scrollOffset, _init_extra_scrollOffset, _init_navigationEvents, _init_extra_navigationEvents, _init_entries, _init_extra_entries, _init_activeId, _init_extra_activeId, _initProto],
      c: [_RuiToc, _initClass]
    } = _applyDecs(this, [customElement("rui-toc")], [[prop({
      type: String,
      attribute: "target",
      defaultValue: ""
    }), 0, "target"], [prop({
      type: String,
      attribute: "heading-selector",
      defaultValue: "h2,h3"
    }), 0, "headingSelector"], [prop({
      type: String,
      defaultValue: "On this page"
    }), 0, "label"], [prop({
      type: Number,
      attribute: "scroll-offset",
      defaultValue: 120
    }), 0, "scrollOffset"], [prop({
      type: String,
      attribute: "navigation-events",
      defaultValue: ""
    }), 0, "navigationEvents"], [state, 0, "entries"], [state, 0, "activeId"], [onUpdated(["target", "headingSelector", "scrollOffset", "navigationEvents"]), 2, "onScanSettingsUpdated"], [bound, 2, "onLinkClick"]], 0, void 0, RadiantElement));
  }
  target = (_initProto(this), _init_target(this, ""));
  headingSelector = (_init_extra_target(this), _init_headingSelector(this, "h2,h3"));
  label = (_init_extra_headingSelector(this), _init_label(this, "On this page"));
  scrollOffset = (_init_extra_label(this), _init_scrollOffset(this, 120));
  navigationEvents = (_init_extra_scrollOffset(this), _init_navigationEvents(this, ""));
  entries = (_init_extra_navigationEvents(this), _init_entries(this, []));
  activeId = (_init_extra_entries(this), _init_activeId(this, null));
  headings = (_init_extra_activeId(this), []);
  scrollRoot = null;
  scrollCleanup = null;
  navigationCleanups = [];
  pendingScrollTargetId = null;
  scrollRafPending = false;
  scrollOffsetTolerance = 4;
  readConfiguredProp(propValue, attributeName) {
    return propValue.trim() || this.getAttribute(attributeName)?.trim() || "";
  }
  readConfiguredNumber(propValue, attributeName, fallback) {
    if (Number.isFinite(propValue) && propValue !== 0) {
      return propValue;
    }
    const fromAttribute = Number(this.getAttribute(attributeName));
    return Number.isFinite(fromAttribute) ? fromAttribute : fallback;
  }
  connectedCallback() {
    super.connectedCallback();
    this.attachNavigationListeners();
  }
  onConnected() {
    this.rebuild();
  }
  disconnectedCallback() {
    this.detachScrollListener();
    this.detachNavigationListeners();
    super.disconnectedCallback();
  }
  onScanSettingsUpdated() {
    this.detachNavigationListeners();
    this.attachNavigationListeners();
    this.rebuild();
  }
  rebuild() {
    this.detachScrollListener();
    this.headings = [];
    this.entries = [];
    this.activeId = null;
    this.pendingScrollTargetId = null;
    this.scrollRoot = null;
    const root = this.resolveTarget();
    if (!root) {
      return;
    }
    const headings = querySelectorAllSafe(root, this.readConfiguredProp(this.headingSelector, "heading-selector") || "h2,h3");
    if (headings.length === 0) {
      return;
    }
    const usedIds = /* @__PURE__ */new Set();
    const entries = headings.map(heading => {
      const id = ensureUniqueHeadingId(heading, usedIds);
      return {
        id,
        label: (heading.textContent || "").trim(),
        depth: this.headingDepth(heading)
      };
    });
    this.headings = headings;
    this.entries = entries;
    this.scrollRoot = this.resolveScrollRoot(root);
    this.attachScrollListener();
    this.updateActiveHeading();
  }
  resolveTarget() {
    const selector = this.readConfiguredProp(this.target, "target");
    if (selector) {
      return querySelectorSafe(document, selector);
    }
    return this.parentElement;
  }
  resolvedScrollOffset() {
    return this.readConfiguredNumber(this.scrollOffset, "scroll-offset", 120);
  }
  /**
   * Nearest ancestor (including the target) that scrolls vertically, else `window`.
   */
  resolveScrollRoot(from) {
    let node = from;
    while (node && node !== document.documentElement && node !== document.body) {
      const overflowY = getComputedStyle(node).overflowY;
      if (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") {
        return node;
      }
      node = node.parentElement;
    }
    return window;
  }
  headingDepth(heading) {
    const level = Number.parseInt(heading.tagName.slice(1), 10);
    return Number.isFinite(level) ? level : 2;
  }
  attachNavigationListeners() {
    if (isServer || !this.isConnected) {
      return;
    }
    const handler = () => this.rebuild();
    for (const eventName of parseCommaSeparated(this.readConfiguredProp(this.navigationEvents, "navigation-events"))) {
      document.addEventListener(eventName, handler);
      this.navigationCleanups.push(() => document.removeEventListener(eventName, handler));
    }
  }
  detachNavigationListeners() {
    for (const cleanup of this.navigationCleanups) {
      cleanup();
    }
    this.navigationCleanups = [];
  }
  attachScrollListener() {
    if (isServer || !this.isConnected) {
      return;
    }
    const onScroll = () => {
      if (this.scrollRafPending) {
        return;
      }
      this.scrollRafPending = true;
      requestAnimationFrame(() => {
        this.updateActiveHeading();
        this.scrollRafPending = false;
      });
    };
    const root = this.scrollRoot ?? window;
    if (root === window) {
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      this.scrollCleanup = () => window.removeEventListener("scroll", onScroll);
      return;
    }
    root.addEventListener("scroll", onScroll, {
      passive: true
    });
    this.scrollCleanup = () => root.removeEventListener("scroll", onScroll);
  }
  detachScrollListener() {
    this.scrollCleanup?.();
    this.scrollCleanup = null;
  }
  isScrollAtBottom() {
    const root = this.scrollRoot ?? window;
    if (!(root instanceof HTMLElement)) {
      const scrollHeight = document.documentElement.scrollHeight;
      const viewport = window.innerHeight;
      if (scrollHeight <= viewport + 1) {
        return false;
      }
      return window.scrollY + viewport >= scrollHeight - 10;
    }
    if (root.scrollHeight <= root.clientHeight + 1) {
      return false;
    }
    return root.scrollTop + root.clientHeight >= root.scrollHeight - 10;
  }
  activeLineY() {
    return trackingLineY(this.scrollRoot ?? window, this.resolvedScrollOffset() + this.scrollOffsetTolerance);
  }
  updateActiveHeading() {
    if (this.headings.length === 0) {
      return;
    }
    if (this.isScrollAtBottom()) {
      this.pendingScrollTargetId = null;
      const lastId = this.headings[this.headings.length - 1]?.id;
      if (lastId) {
        this.setActiveId(lastId);
      }
      return;
    }
    if (this.pendingScrollTargetId) {
      const pendingHeading = this.findHeadingById(this.pendingScrollTargetId);
      if (!pendingHeading) {
        this.pendingScrollTargetId = null;
      } else if (!this.hasPendingScrollReachedTarget(pendingHeading)) {
        this.setActiveId(this.pendingScrollTargetId);
        return;
      } else {
        this.pendingScrollTargetId = null;
      }
    }
    const lineY = this.activeLineY();
    let activeId = null;
    for (const heading of this.headings) {
      if (heading.getBoundingClientRect().top <= lineY) {
        activeId = heading.id;
      } else {
        break;
      }
    }
    this.setActiveId(activeId ?? this.headings[0].id);
  }
  setActiveId(id) {
    if (this.activeId === id) {
      return;
    }
    this.activeId = id;
  }
  findHeadingById(id) {
    return this.headings.find(heading => heading.id === id) ?? null;
  }
  hasPendingScrollReachedTarget(heading) {
    return heading.getBoundingClientRect().top <= this.activeLineY();
  }
  onLinkClick(event, id) {
    const mouseEvent = event;
    if (mouseEvent.metaKey || mouseEvent.ctrlKey || mouseEvent.shiftKey || mouseEvent.altKey || mouseEvent.button !== 0) {
      return;
    }
    const heading = this.findHeadingById(id);
    if (!heading) {
      return;
    }
    event.preventDefault();
    this.pendingScrollTargetId = id;
    this.setActiveId(id);
    this.scrollToHeading(id, heading);
  }
  scrollToHeading(id, heading) {
    const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}#${id}`);
    scrollHeadingIntoView(heading, this.scrollRoot ?? window, this.resolvedScrollOffset(), behavior);
  }
  render() {
    if (this.entries.length === 0) {
      return null;
    }
    return /* @__PURE__ */jsxs("nav", {
      class: "rui-toc",
      "aria-label": this.label,
      children: [this.label ? /* @__PURE__ */jsx("p", {
        class: "rui-toc__label",
        children: this.label
      }) : null, /* @__PURE__ */jsx("ul", {
        class: "rui-toc__list",
        children: this.entries.map(entry => /* @__PURE__ */jsx("li", {
          class: entry.depth >= 3 ? "rui-toc__item rui-toc__item--depth-3" : "rui-toc__item",
          children: /* @__PURE__ */jsx("a", {
            href: `#${entry.id}`,
            class: entry.id === this.activeId ? "rui-toc__link rui-toc__link--active" : "rui-toc__link",
            "on:click": event => this.onLinkClick(event, entry.id),
            children: entry.label
          })
        }))
      })]
    });
  }
  static {
    _initClass();
  }
}
export { _RuiToc as RuiToc };